/* eslint-disable react/prop-types */
import { Component, useState, useEffect } from 'react';
import { Layout } from 'antd';
import propTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import MenueItems from './MenueItems';
import AuthInfo from '../components/utilities/auth-info/info';

const { Header, Sider, Content } = Layout;

const SIDEBAR_BG   = '#064e3b';
const HEADER_BG    = '#ffffff';
const BORDER_COLOR = '#e5e7eb';
const SIDEBAR_BORDER = 'none';

function PHClock() {
  const fmtTime = () => new Date().toLocaleTimeString('en-PH', {
    timeZone: 'Asia/Manila',
    hour: '2-digit', minute: '2-digit', second: '2-digit',
  });
  const fmtDate = () => new Date().toLocaleDateString('en-PH', {
    timeZone: 'Asia/Manila',
    weekday: 'short', month: 'short', day: 'numeric', year: 'numeric',
  });
  const [time, setTime] = useState(fmtTime);
  const [date, setDate] = useState(fmtDate);
  useEffect(() => {
    const id = setInterval(() => { setTime(fmtTime()); setDate(fmtDate()); }, 1000);
    return () => clearInterval(id);
  }, []);
  return (
    <div style={{ textAlign: 'right', marginRight: 8 }}>
      <p style={{ margin: 0, fontSize: 13, fontWeight: 600, color: '#111827', lineHeight: 1.2, fontVariantNumeric: 'tabular-nums' }}>
        {time}
      </p>
      <p style={{ margin: 0, fontSize: 10, color: '#9ca3af', lineHeight: 1.2, letterSpacing: '0.04em' }}>
        {date}
      </p>
    </div>
  );
}
const SIDEBAR_W    = 260;
const SIDEBAR_COLLAPSED_W = 0;
const HEADER_H     = 64;

const ThemeLayout = (WrappedComponent) => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        collapsed: window.innerWidth <= 1200,
        mobileOpen: false,
      };
      this.updateDimensions = this.updateDimensions.bind(this);
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions() {
      this.setState({ collapsed: window.innerWidth <= 1200 });
    }

    render() {
      const { collapsed, mobileOpen } = this.state;
      const { rtl } = this.props;

      const isMobile = window.innerWidth <= 991;
      const sidebarVisible = isMobile ? mobileOpen : !collapsed;

      const toggleCollapsed = () => this.setState((s) => ({ collapsed: !s.collapsed }));
      const toggleMobile    = () => this.setState((s) => ({ mobileOpen: !s.mobileOpen }));
      const closeMobile     = () => this.setState({ mobileOpen: false });

      const toggleCollapsedMobile = () => {
        if (isMobile) closeMobile();
      };

      const userRole = localStorage.getItem('user_role') || '';
      const path = `/${userRole.toLowerCase()}`;

      return (
        <div style={{ minHeight: '100vh', background: '#f0f2f5', display: 'flex', flexDirection: 'column' }}>

          {/* ── Header ──────────────────────────────────── */}
          <Header style={{
            position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
            height: HEADER_H,
            background: HEADER_BG,
            borderBottom: `1px solid ${BORDER_COLOR}`,
            borderTop: `3px solid #0f8269`,
            display: 'flex', alignItems: 'center',
            padding: '0 20px',
            gap: 16,
          }}>
            {/* Hamburger */}
            <button
              type="button"
              onClick={isMobile ? toggleMobile : toggleCollapsed}
              style={{
                background: 'none', border: 'none', cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: 36, height: 36, borderRadius: 8, flexShrink: 0,
                color: '#6b7280',
                transition: 'background 0.15s',
              }}
              aria-label="Toggle sidebar"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <line x1="3" y1="6"  x2="21" y2="6"  stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                <line x1="3" y1="12" x2="21" y2="12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
                <line x1="3" y1="18" x2="21" y2="18" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round"/>
              </svg>
            </button>

            {/* Logo */}
            <Link to={path} style={{ display: 'flex', alignItems: 'center', gap: 10, textDecoration: 'none', flexShrink: 0 }}>
              <img src="/top_nav.svg" alt="eFAST" style={{ height: 36, width: 'auto' }} />
            </Link>

            {/* Spacer */}
            <div style={{ flex: 1 }} />

            {/* PH Time */}
            <PHClock />

            {/* Divider */}
            <div style={{ width: 1, height: 32, background: '#e5e7eb', flexShrink: 0 }} />

            {/* User info */}
            <AuthInfo />
          </Header>

          {/* ── Mobile shade ────────────────────────────── */}
          {isMobile && mobileOpen && (
            /* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */
            <div
              onClick={closeMobile}
              style={{
                position: 'fixed', inset: 0, zIndex: 998,
                background: 'rgba(0,0,0,0.45)',
              }}
            />
          )}

          {/* ── Sidebar ─────────────────────────────────── */}
          <Sider
            width={SIDEBAR_W}
            collapsedWidth={SIDEBAR_COLLAPSED_W}
            collapsed={isMobile ? !mobileOpen : collapsed}
            style={{
              position: 'fixed',
              top: HEADER_H,
              [!rtl ? 'left' : 'right']: 0,
              bottom: 0,
              zIndex: 999,
              background: SIDEBAR_BG,
              borderRight: SIDEBAR_BORDER,
              overflowY: 'auto',
              overflowX: 'hidden',
              transition: 'width 0.2s',
            }}
          >
            <MenueItems toggleCollapsed={toggleCollapsedMobile} />

            {/* Bottom version tag */}
            <div style={{
              position: 'absolute', bottom: 16, left: 0, right: 0,
              textAlign: 'center',
            }}>
              <span style={{
                fontSize: 10, color: 'rgba(255,255,255,0.3)',
                letterSpacing: '0.05em',
              }}>
                eFAST v2.0
              </span>
            </div>
          </Sider>

          {/* ── Main content ────────────────────────────── */}
          <Layout style={{
            marginTop: HEADER_H,
            marginLeft: !rtl && !isMobile && !collapsed ? SIDEBAR_W : 0,
            marginRight: rtl && !isMobile && !collapsed ? SIDEBAR_W : 0,
            transition: 'margin 0.2s',
            minHeight: `calc(100vh - ${HEADER_H}px)`,
            background: '#f0f2f5',
            display: 'flex',
            flexDirection: 'column',
          }}>
            <Content style={{ padding: '40px 40px 40px', flex: 1, display: 'flex', flexDirection: 'column' }}>
              <WrappedComponent {...this.props} />
            </Content>
          </Layout>
        </div>
      );
    }
  }

  const mapStateToProps = (state) => ({
    layoutMode: state.ChangeLayoutMode.mode,
    rtl: state.ChangeLayoutMode.rtlData,
    topMenu: state.ChangeLayoutMode.topMenu,
  });

  LayoutComponent.propTypes = {
    layoutMode: propTypes.string,
    rtl: propTypes.bool,
    topMenu: propTypes.bool,
  };

  return connect(mapStateToProps)(LayoutComponent);
};

export default ThemeLayout;
